import React from 'react'
import { render } from 'react-dom'
import Routes from './navigation/routes'

require('./styles/fonts.scss')

render(<Routes />, document.getElementById('app'))
